module.exports = __webpack_public_path__ + "img/top-wave.ff40a518.png";